import { createBrowserRouter } from "react-router";
import type { RouterState } from "react-router";
import { appRoutes } from "./appRoutes";
import { setCurrentLocation, currentLocation } from "routes/currentLocation";

export const router = createBrowserRouter(appRoutes);

setCurrentLocation(router.state.location);
router.subscribe((state: RouterState) => setCurrentLocation(state.location));

export { currentLocation };
